import { AxiosError } from "axios"

export type InitialStateLogin = {
    login: {
        data: string;
        loading: boolean;
        error: AxiosError | null
    }
    changePassword: {
        data: string;
        loading: boolean;
        error: AxiosError | null
    },
    currentUser: {
        name: string;
    },
    claims: {
        data: string[]
    }
} 


//авторизация
export const START_LOGIN = 'START_LOGIN';
interface StartLoginList {
    type: typeof START_LOGIN;
    payload: Login
}
export const STOP_LOGIN = 'STOP_LOGIN';
interface StopLoginList {
    type: typeof STOP_LOGIN;
}
export const FILL_LOGIN = 'FILL_LOGIN';
interface FillLoginList {
    type: typeof FILL_LOGIN;
    payload: Login
}
export const ERROR_LOGIN = 'ERROR_LOGIN';
interface ErrorLoginList {
    type: typeof ERROR_LOGIN;
    payload: AxiosError;
}
export const ASYNC_LOGIN = 'ASYNC_LOGIN';



//сброс
export const START_CHANGE_PASSWORD = 'START_CHANGE_PASSWORD';
interface StartChangePasswordList {
    type: typeof START_CHANGE_PASSWORD;
    payload: ChangePassword
}
export const STOP_CHANGE_PASSWORD = 'STOP_CHANGE_PASSWORD';
interface StopChangePasswordList {
    type: typeof STOP_CHANGE_PASSWORD;
}
export const FILL_CHANGE_PASSWORD = 'FILL_CHANGE_PASSWORD';
interface FillChangePasswordList {
    type: typeof FILL_CHANGE_PASSWORD;
    payload: ChangePassword
}
export const ERROR_CHANGE_PASSWORD = 'ERROR_CHANGE_PASSWORD';
interface ErrorChangePasswordList {
    type: typeof ERROR_CHANGE_PASSWORD;
    payload: AxiosError;
}
export const ASYNC_CHANGE_PASSWORD = 'ASYNC_CHANGE_PASSWORD';

export const SET_USER = 'SET_USER';
interface SetUser {
    type: typeof SET_USER;
    payload: AxiosError;
}
export const SET_CLAIMS = 'SET_CLAIMS';
interface SetClaims {
    type: typeof SET_CLAIMS;
    payload: string[];
}

export type ActionContractorType = 
StartLoginList |
StopLoginList |
FillLoginList |
ErrorLoginList |
StartChangePasswordList |
StopChangePasswordList |
FillChangePasswordList |
ErrorChangePasswordList |
SetUser |
SetClaims



export type LoginAuth = {
    userName: string;
    password: string;
};

export type Login = {
    userId: number;
    expires: number;
    token: string;
    defaultPage: string;
    role: string;
    fullName: string;
    claims: string[];
  }

export type ChangePassword = {
    currentPassword: string,
    newPassword: string
}